import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Modal } from "bootstrap";
import HttpAPICall from "../../../services/HttpAPICall";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";

function UploadPhoto({assetMatrixId}, ref) {

    const docUrl            =   BACKOFFICE_BASE_URL + '/asset_matrix/upload_doc';
    const access_token      =   useSelector(state => state.auth.access_token);
    const history           =   useHistory();


    const modalElem                     =   useRef(null);
    const modal                         =   useRef(null);
    
    const addDocumentFormInit           =   {
        am_id                               :   assetMatrixId,
        base64_document                     :   '',
        file_name                           :   '',
        file                                :   null
    };
    
    const [submitForm, setSubmitForm]   =   useState(false);
    const [documentData, setDocumentData]=  useState(addDocumentFormInit);


    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            modalOpen();
        }
    }));

    useEffect(() => {
        modalElem.current   =   document.getElementById("picModal");
        modal.current       =   new Modal(modalElem.current, { keyboard: false, backdrop: false });
    }, []);

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose        =   ()  =>  {
        setDocumentData(addDocumentFormInit);
        if (modal.current) { modal.current.hide(); }
    }
    const goToList   =  () => {
        history.push({
            pathname: '/asset_matrix_list',
            state: { assetMatrixId }
        });
    }

    const handleFileChange  =   async (e) => {
        let file                            =   e.target.files[0];
        if(file) {
            let filename                    =   file.name;
            let base64_document             =   await convertBase64(file);
            setDocumentData(pre => ({
                ...pre, 
                am_id           :   assetMatrixId,
                base64_document :   base64_document,
                file_name       :   filename
            }))
        }
    }

    const convertBase64     =   (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result.replace("data:", "").replace(/^.+,/, ""));
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }


    const submitFormData    =   (e)  =>  {
        e.preventDefault();
        setSubmitForm(true);
        HttpAPICall.withAthorization('post', docUrl, access_token, {}, documentData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            modalClose();
            goToList();
        })
        .then(() => setSubmitForm(false));
    }

  return (
    <div className="modal fade" id="picModal" tabIndex="-1" ref={modalElem}>
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="searchAssetModalLabel">Upload Photo</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => modalClose()}></button>
                </div>
                <form id="modelSearchForm" onSubmit={submitFormData}>
                    <div className="modal-body">
                        <div className="row my-2">
                            <label className="col-sm-3 col-form-label require">Document</label>
                            <div className="col-sm-7">
                                <input
                                    name="file"
                                    type="file"
                                    className="form-control"
                                    autoComplete="off"
                                    onChange={(e) => {handleFileChange(e)}}
                                    placeholder="Please upload document"
                                    value={documentData.file}
                                    required={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" disabled={submitForm} className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => modalClose()}>Close</button>
                        <button type="submit" disabled={submitForm} className="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default forwardRef(UploadPhoto)
